import request from "./api";
/**
 *    marketingProjectManagement   真实任务api
 *                         Author by jxl. on 2022.04.24
 *
 * */

//删除学生作答数据汇总
export const deleteAnswer = (params, opts) =>
  request("/api-task/answerSummary/deleteAnswer", params, {
    ...opts,
    method: "post",
  });

//查询学生作答数据汇总
export const queryAnswer = (params, opts) =>
  request("/api-task/answerSummary/queryAnswer", params, {
    ...opts,
    method: "post",
  });

//新增学生作答数据汇总
export const saveAnswer = (params, opts) =>
  request("/api-task/answerSummary/saveAnswer", params, {
    ...opts,
    method: "post",
  });

//修改学生作答数据汇总
export const updateAnswer = (params, opts) =>
  request("/api-task/answerSummary/updateAnswer", params, {
    ...opts,
    method: "post",
  });


//保存公司
export const SaveCompany = (params, opts) =>
  request("/api-task/company/save", params, {
    ...opts,
    method: "post",
  });

//编辑公司
export const updateCompany = (params, opts) =>
  request("/api-task/company/update", params, {
    ...opts,
    method: "post",
  });

//删除公司
export const deleteCompany = (params, opts) =>
  request("/api-task/company/delete/"+ params.id, params, {
    ...opts,
    method: "post",
  });

//公司员工列表

export const companyUserList = (params, opts) =>
  request("/api-task/companyUser/pg/list", params, {
    ...opts,
    method: "post",
  });


  export const updateStatus = (params, opts) =>
  request("/api-task/companyTeam/updateStatus", params, {
    ...opts,
    method: "post",
  });
//班级公司
export const getAllStudent = (params, opts) =>
  request('/api-teachingaffair/teachingAffair/queryStudentPage', params, {
    ...opts,
    method: 'post'
  });
// 导入学员到班级中
export const addStudentInto = (params, opts) =>
  request('/api-course/class/addUser', params, {
    ...opts,
    method: 'post'
  });

// 删除公司项目员工
export const deleteCompanyProjectStaff = (params, opts) =>
  request("/api-task/companyProjectUser/delete", params, {
    ...opts,
    method: "post",
  });


//

//项目分配
export const distribute = (params, opts) =>
  request("/api-task/companyProjectUser/distribute", params, {
    ...opts,
    method: "post",
  });

//添加公司项目员工
export const saveCompanyStaff = (params, opts) =>
  request("/api-task/companyProjectUser/save", params, {
    ...opts,
    method: "post",
  });

//删除公司员工
export const delCompanyStaff = (params, opts) =>
  request("/api-task/companyUser/delete", params, {
    ...opts,
    method: "post",
  });

//查询公司列表
export const CompanyList = (params, opts) =>
  request("/api-task/company/list", params, {
    ...opts,
    method: "post",
  });

//查询项目列表
export const projectList = (params, opts) =>
  request("/api-task/project/findAuthList", params, {
    ...opts,
    method: "post",
  });

//新增项目信息
export const saveOrUpdate = (params, opts) =>
  request("/api-task/project/saveOrUpdate", params, {
    ...opts,
    method: "post",
  });

  //发布项目
export const projectPublish = (params, opts) =>
request("/api-task/project/publish", params, {
  ...opts,
  method: "post",
});

//删除项目信息
export const projectCatalogDelete = (params, opts) =>
  request("/api-task/project/delete",params,{
    ...opts,
    method: "post",
  });
// 行政班级
export const getTeachingClass = (params, opts) =>
  request('/api-teachingaffair/teachingAffair/teachingClass', params, {
    ...opts
  });
// 教学班中全部的学员列表
export const getStudentList = (params, opts) =>
  request('/api-course/class/get', params, {
    ...opts,
    method: 'post'
  });
// 获取所有的待批名单
export const getApprovedList = (params, opts) =>
  request('/api-course/class/share/get', params, {
    ...opts,
    method: 'post'
  });

// 添加公司员工
export const Usersave = (params, opts) =>
  request('/api-task/companyUser/save', params, {
    ...opts,
    method: 'post'
  });

//查询公司目录
export const projectCatalogList = (params, opts) =>
  request('/api-task/projectCatalog/list', params, {
    ...opts,
    method: 'post'
  });


// 新增公司目录
export const projectCatalogsave = (params, opts) =>
  request('/api-task/projectCatalog/save', params, {
    ...opts,
    method: 'post'
  });
// 修改公司目录
export const editCatalogSave = (params, opts) =>
  request('/api-task/projectCatalog/update', params, {
    ...opts,
    method: 'post'
  });

// 删除公司目录
export const projectCatalogdel = (params) =>
  request('/api-task/projectCatalog/delete', params,);

// 查询目录资源
export const projectResourceQueryList = (params) =>
  request('/api-task/projectCatalog/getResourceByCatalog', params);

// 上传
export const realTaskUploadUploadFile = (params, opts) =>
  request('/realTaskUpload/uploadFile', params, {
    ...opts,
    method: 'post'
  });

  // 获取公司下每个项目已绑定的员工
export const findProjectUserList = (params) =>
request('/api-task/companyProjectUser/findProjectUserList', params);

  // 获取公司详情
  export const findById = (params) =>
  request('/api-task/company/findById', params);

  // 删除
export const projectResourceDelete = (params) =>
request('/api-task/projectResource/delete', params);


// 公司团队-根据多个队长生成多个团队
export const saveTeamByCap = (params, opts) =>
  request('/api-task/companyTeam/saveTeamByCap', params, {
    ...opts,
    method: 'post'
  });
  // 公司团队列表
 export  const findCompanyTeamList = (params, opts) =>
  request('/api-task/companyTeam/findList', params, {
    ...opts,
    method: 'post'
  });


  // 公司团队详情
export const CompanyTeamDetails = (params) =>
request('/api-task/companyTeam/findById', params);


// 公司团队-添加队员
 export  const companyTeamInsert = (params, opts) =>
  request('/api-task/companyTeam/insert', params, {
    ...opts,
    method: 'post'
  });
// 获取团队下所有成员
export const findTeamUserById = (params) =>
request('/api-task/company/findById', params);

// 公司团队-随机生成团队
 export  const generateByRandom = (params, opts) =>
  request('/api-task/companyTeam/generateByRandom', params, {
    ...opts,
    method: 'post'
  });

// 公司团队-删除成员
 export  const deleteUser = (params, opts) =>
  request('/api-task/companyTeam/deleteUser', params, {
    ...opts,
    method: 'post'
  });
  // 查询项目详情
  export const projectFindOne = (id) =>
request('/api-task/project/findOne/'+ id);
// 进入办公区前的判断
export  const judgeTeam = (companyId) =>
  request('/api-task/companyTeam/findUserTeamStatus/'+companyId);
// 进入办公区数据获取
export  const getTeamMsg = (companyId) =>
  request('/api-task/company/findById/?id='+companyId);
// 查询分配项目的指派人员
export  const getProjectUser = (companyId) =>
  request('/api-task/companyProjectUser/getProjectUser/'+companyId);
// 获取项目树结构
export  const getProjectTree = (companyId) =>
  request('/api-task/projectCatalog/findCompanyCatalogs/'+companyId);


// WEBPACK FOOTER //
// ./src/api/marketingProjectManagement.js